import { render, staticRenderFns } from "./OrganizationSelect.vue?vue&type=template&id=06fe6f38&scoped=true&"
import script from "./OrganizationSelect.vue?vue&type=script&lang=ts&"
export * from "./OrganizationSelect.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationSelect.vue?vue&type=style&index=0&id=06fe6f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fe6f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
